"use client";

import styles from "./index.module.scss";
import classNames from "classnames";
import { useParams, useRouter } from "next/navigation";
import type { NetworkType } from "@/types/general.types";

/**
 * A React component for toggling between "testnet" and "mainnet" views.
 *
 * @returns {JSX.Element} The network switch component.
 *
 * @remarks
 * - Uses `useRouter` for navigation and `useParams` for URL params.
 * - Preserves query parameters when switching networks.
 * - Highlights the active network button.
 *
 * @example
 * ```tsx
 * <NetworkSwitch />
 * ```
 */
const NetworkSwitch = () => {
  const router = useRouter();
  const { network } = useParams() as { network: string };

  const handleSwitch = async (type: NetworkType) => {
    const urlParams = new URLSearchParams(window.location.search);
    router.push(
      `/bridge-scanner/${type}${urlParams.size ? `?${urlParams}` : ""}`,
    );
  };

  return (
    <div className={styles.switchContainer}>
      <button
        className={classNames(network === "mainnet" && styles.active)}
        onClick={() => handleSwitch("mainnet")}
      >
        MAINNET
      </button>
      <button
        className={classNames(network === "testnet" && styles.active)}
        onClick={() => handleSwitch("testnet")}
      >
        TESTNET
      </button>
    </div>
  );
};

export default NetworkSwitch;
